import { SurveyStyles } from "../types/Survey";

export const darkKeyFor = (key: string) => `darkMode${key[0].toUpperCase()}${key.slice(1)}`;

const CSS_COLOR = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\([\d\s.,%\/]+\)|[a-z]+)$/i;
export const cssColor = (value: unknown): string | undefined =>
    typeof value === "string" && CSS_COLOR.test(value.trim()) ? value.trim() : undefined;

export const darkFill = (styles: SurveyStyles, key: string) => cssColor(styles[darkKeyFor(key)]) || styles[key];

export const darkText = (styles: SurveyStyles, key: string, fallback?: string) => cssColor(styles[darkKeyFor(key)]) || fallback;
